<div class="error-container">
    <h1>Error</h1>
    <p class="error-message">{{errorMessage}}</p>
</div>
